import { render } from "./ProPointUpdate.vue?vue&type=template&id=45ea5d59"
import script from "./ProPointUpdate.vue?vue&type=script&lang=js"
export * from "./ProPointUpdate.vue?vue&type=script&lang=js"

import "./ProPointUpdate.vue?vue&type=style&index=0&id=45ea5d59&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__